export default "__VITE_ASSET__53c9f940__"